import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// --- RxJs
import { catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

// --- 3rd Party
import { retryBackoff } from 'backoff-rxjs';

// --- HS Code
import { environment } from '../../../../environments/environment';
import { PatchModel, PatchOperations, TermsAndConditionsModel } from '../../../models';
import { AppService } from '../app.service';
import { TermsAndConditionsBaseService } from './terms-and-conditions-base.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class TermsAndConditionsMockService extends TermsAndConditionsBaseService {

  private modelAgreement: TermsAndConditionsModel | undefined;
  private modelEmailOpt: TermsAndConditionsModel | undefined;

    constructor(
      private httpClient: HttpClient,
      appService: AppService,
    ) {
      super(appService);
    }

    clearState(): void {
      this._termsAndConditions$.next(null);

      this.modelAgreement =
        {
          hasAcceptedTerms: false,
          termsAgreementId: '77848C9E-AD9A-460D-A204-84F7CB20CECE'
        } as TermsAndConditionsModel;

      this.modelEmailOpt =
        {
          emailOptIn: true,
          userPreferenceEmailOptInId: 'DC7C1424-1604-4E84-839E-D78D5EF4585C'
        } as TermsAndConditionsModel;
    }

    loadUserAgreementPreferences(): void {
      const termsAndConditions =
        { hasAcceptedTerms: false,
          emailOptIn: false,
          termsAgreementId: '77848C9E-AD9A-460D-A204-84F7CB20CECE',
          userPreferenceEmailOptInId: 'DC7C1424-1604-4E84-839E-D78D5EF4585C' } as TermsAndConditionsModel;
      this._termsAndConditions$.next(termsAndConditions);
    }

    updateUserAgreementSelection(): void {
      if (!this.modelAgreement) return;

      this._sendUserPreferenceSelection(this.modelAgreement.termsAgreementId, this.modelAgreement.hasAcceptedTerms, 'Terms');
    }

    updateUserEmailOptInSelection(): void {
      if (!this.modelEmailOpt) return;
      
      this._sendUserPreferenceSelection(this.modelEmailOpt.userPreferenceEmailOptInId, this.modelEmailOpt.emailOptIn, 'EmailOptIn');
    }

    private _sendUserPreferenceSelection(id: string, value: boolean, valueToUpdate: string): void {
      const agreementUrl = environment.apiConfig.surveyApiUrl + environment.apiConfig.agreementApi + `/${id}`;

      const model = {
        operation: PatchOperations.replace,
        path: valueToUpdate,
        value: value.toString()
      } as PatchModel;

      this.httpClient.patch<TermsAndConditionsModel>(agreementUrl, model).pipe(
        retryBackoff(environment.retryConfig),
        catchError(this._modelError.bind(this))
      ).subscribe(() => { });
    }

    private _modelError(err: any): Observable<TermsAndConditionsModel | null> {
      return of(null);
    }

  }
